<template>
  <div v-if="data_customer">
    <collapse-portlet title="Users" :expanded="false" icon="la la-users">
      <div class="row">
        <div class="col-6">
          <button type="button" class="btn btn-ss w-100 mb-2"
                  data-toggle="modal"
                  data-target="#add-existing-user-modal">
            <i class="la la-plus" /> Add Existing User
          </button>
        </div>
        <div class="col-6">
          <button type="button" class="btn btn-ss-standout w-100 mb-2"
                  @click="fireModal(modals.user)">
            <i class="la la-plus" /> Add User
          </button>
          <add-user :modal-name="modals.user" :customer="data_customer" />
        </div>

        <add-user :customer="data_customer" />
        <add-existing-user-modal :customer="data_customer" />
        <div v-for="(user, index) in normal_users" :key="index" class="no-gutters col-12 col-md-6 col-xl-4 user">
          <user-card :user="user" :auth-user="activeUser" :in-admin-area="true" />
        </div>
      </div>
    </collapse-portlet>

    <collapse-portlet v-if="customer_plan_has_uploaders" title="Uploaders"
                      :expanded="false"
                      icon="la la-users">
      <add-uploader :name="modal_name" :customer="data_customer" />
      <button type="button" class="btn btn-ss-standout w-100 mb-2"
              @click="$modal.show(modals.uploader)">
        <i class="la la-plus" /> Add Uploader
      </button>
      <add-uploader v-perms="['third_party_uploader']" :modal-name="modals.uploader" :customer="data_customer" />
      <div v-for="(user, index) in uploader_users" :key="index" class="no-gutters col-12 col-md-6 col-xl-4 user">
        <uploader-card :user="user" :active-user="activeUser" />
      </div>
    </collapse-portlet>
    <delete-confirm-modal :name="modals.delete_confirm"
                          :entities-to-delete="user_to_delete"
                          entity-type="User" />
  </div>
</template>

<script>
import AddUser from "VueModals/AddUserModal";
import AddUploader from "VueModals/AddUploaderModal";
import UserCard from "VuePartials/UserCard";
import UploaderCard from "VuePartials/UploaderCard";
import CollapsePortlet from "VueComponents/CollapsePortlet";
import DeleteConfirmModal from 'VueModals/DeleteConfirmModal';
import AddExistingUserModal from "VuePartials/AddExistingUserModal";
import UserRolesMixin from "VueMixins/UserRolesMixin";

export default {
  components: {
    CollapsePortlet,
    AddUser,
    AddUploader,
    UserCard,
    UploaderCard,
    DeleteConfirmModal,
    AddExistingUserModal,
  },
  mixins: [UserRolesMixin],
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeUser: window.user,
      user_to_delete: [],
      modals: {
        uploader: `add-uploader-modal`,
        user: `add-user-modal`,
        delete_confirm: `delete-confirm-modal`,
      },
      modal_name: 'add-uploader-modal',
      data_customer: this.customer,
    };
  },
  computed: {
    users() {
      return this.data_customer.users;
    },
    uploader_users() {
      return _.filter(this.users, user => user.is_uploader);
    },
    normal_users() {
      return _.filter(this.users, user => !user.is_uploader);
    },
    customer_plan_has_uploaders() {
      return _.find(this.data_customer.plan.features, feature => feature.slug === 'third_party_uploader');
    },
  },
  mounted() {
    EventBus.$on("delete-user", async (payload) => {
      this.user_to_delete = [payload];
      const res = await this.fireModal(this.modals.delete_confirm);
      if (res.data.confirm) {
        try {
          await axios.delete(`/api/v1/user/${payload.uuid}`);
          this.data_customer.users = _.filter(this.users, user => user.uuid !== payload.uuid);
          toastr.success('User Deleted');
        } catch (err) {
          window.handleAxiosError(err);
        }
      }
    });

    EventBus.$on("user-added", (payload) => {
      this.users.unshift(payload);
    });

    EventBus.$on("toggle-admin-status", (payload) => {
      axios.patch(`/api/v1/user/roles/${payload.uuid}/isAdmin`, {
        isAdmin: !payload.is_admin,
      }).then(() => {
        // Update the user frontend values.
        const user = _.find(this.users, user => user.uuid === payload.uuid);
        if (user) {
          user.is_admin = !payload.is_admin;
        }
        toastr.success("User Admin Status Updated.");
      }).catch(() => {
        toastr.error("Unable to change admin privileges. Please try again later.");
      });
    });

    EventBus.$on("toggle-active-status", (payload) => {
      axios.patch(`/api/v1/user/roles/${payload.uuid}/changeStatus`, {
        status: !payload.status,
      }).then(() => {
        // Update the user frontend values.
        const user = _.find(this.users, user => user.uuid === payload.uuid);
        if (user) {
          user.status = !payload.status;
        }
        toastr.success("Status Updated");
      }).catch(() => {
        toastr.error("Unable to change status. Please try again later.");
      });
    });
  },
};
</script>

<style lang='scss'>
    @use "~AssetsSass/_users.scss" as *;

    .actions {
        button {
            width: 100%;
            border-left: none !important;
            border-right: none !important;
            border-bottom: none !important;
        }
        .dropdown-menu {
            width: 100%;
        }
    }

    .add-user-button {
        margin-left: 14px;
    }

    .swal2-styled.swal2-cancel {
        border: 1px solid #ebedf2 !important;
        color: #212529 !important;
    }

</style>
